module.exports = __webpack_public_path__ + "static/media/Mosprom_GDPR_PP_en.355c12f8.docx";